export const CLEAR_SINGLE_USER_ACTIONS = "CLEAR_SINGLE_USER_ACTIONS"
export const CLEAR_USER_ACTIONS = "CLEAR_USER_ACTIONS"
export const FETCH_COMBINED_STATS = "FETCH_COMBINED_STATS"
export const FETCH_ENGAGEMENT_STATS = "FETCH_ENGAGEMENT_STATS"
export const FETCH_RECENT_USERS = "FETCH_RECENT_USERS"
export const FETCH_SINGLE_USER_ACTIONS = "FETCH_SINGLE_USER_ACTIONS"
export const FETCH_USAGE_DATA = "FETCH_USAGE_DATA"
export const SET_STAT = "SET_STAT"
export const SINGLE_USER_ACTIVITY_IS_AGENT = "SINGLE_USER_ACTIVITY_IS_AGENT"
export const UPDATE_USER_ACTIONS_FILTER = "UPDATE_USER_ACTIONS_FILTER"
export const RECEIVE_RECENT_USERS = "RECEIVE_RECENT_USERS"
export const RECEIVE_SINGLE_USER_ACTIONS = "RECEIVE_SINGLE_USER_ACTIONS"
export const RECEIVE_USAGE_DATA = "RECEIVE_USAGE_DATA"
export const RECEIVE_ENGAGEMENT_STATS = "RECEIVE_ENGAGEMENT_STATS"
export const RECEIVE_COMBINED_STATS = "RECEIVE_COMBINED_STATS"

export const clearSingleUserActions = () => ({
  type: CLEAR_SINGLE_USER_ACTIONS,
})

export const clearUserActions = () => ({
  type: CLEAR_USER_ACTIONS,
})

export const fetchCombinedStats = (success, error) => ({
  type: FETCH_COMBINED_STATS,
  success,
  error,
})

export const fetchEngagementStats = (success, error) => ({
  type: FETCH_ENGAGEMENT_STATS,
  success,
  error,
})

export const fetchRecentUsers = (page, success, error) => ({
  type: FETCH_RECENT_USERS,
  page,
  success,
  error,
})

export const fetchSingleUserActions = (userId, page, recordType, success, error) => ({
  type: FETCH_SINGLE_USER_ACTIONS,
  userId,
  page,
  recordType,
  success,
  error,
})

export const fetchUsageData = (page, success, error) => ({
  type: FETCH_USAGE_DATA,
  page,
  success,
  error,
})

export const setStat = (stat) => ({
  type: SET_STAT,
  stat,
})

export const singleUserActivityIsAgent = (val) => ({
  type: SINGLE_USER_ACTIVITY_IS_AGENT,
  val,
})

export const updateUserActionsFilter = (filter) => ({
  type: UPDATE_USER_ACTIONS_FILTER,
  filter,
})

export const receiveRecentUsers = (recentUsers) => ({
  type: RECEIVE_RECENT_USERS,
  recentUsers,
})

export const receiveSingleUserActions = (singleUserActions) => ({
  type: RECEIVE_SINGLE_USER_ACTIONS,
  singleUserActions,
})

export const receiveUsageData = (usageData) => ({
  type: RECEIVE_USAGE_DATA,
  usageData,
})

export const receiveEngagementStats = (stats) => ({
  type: RECEIVE_ENGAGEMENT_STATS,
  stats,
})

export const receiveCombinedStats = (combinedStats) => ({
  type: RECEIVE_COMBINED_STATS,
  combinedStats,
})
